/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Titles_Pagenotfound2Inputs */

const en_titles_pagenotfound2 = /** @type {(inputs: Titles_Pagenotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing seems to be here`)
};

/**
* | output |
* | --- |
* | "Nothing seems to be here" |
*
* @param {Titles_Pagenotfound2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const titles_pagenotfound2 = /** @type {((inputs?: Titles_Pagenotfound2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Titles_Pagenotfound2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_titles_pagenotfound2(inputs)
});
export { titles_pagenotfound2 as "titles_pageNotFound" }